import "images";
// import "fonts";
import "stylesheets/application";

// These polyfills ensure that modern JS features
import "core-js/stable"
import "regenerator-runtime/runtime"

import "modules/bootstrap";
import "modules/landkit";

import "modules/autosize";
import "modules/sortable";
import "modules/clipboard";
import "modules/chartist";
import "modules/moment";

import "modules/jquery-plugins";
import "modules/datetimepicker";

import "modules/config";
import "modules/profile";
import "modules/subregion_select";
import "modules/dashboard";

import "modules/experts";
import "modules/reports";
import "modules/scheduler";
import "modules/site";
import "modules/qualtrics_admin_wizard";
import "modules/qualtrics_embed";
import "modules/toasts";
import "modules/admin_dropdown_fix";

// Import and start Rails UJS (only if not already loaded)
import Rails from "@rails/ujs";

if (!window.Rails) {
  window.Rails = Rails;
  Rails.start();
  console.log('Rails UJS initialized');
} else {
  console.log('Rails UJS already loaded, skipping initialization');
}
// require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

// Use our custom Rails confirm modal implementation
// This replaces data-confirm-modal with a simpler, more reliable solution
import "modules/rails_confirm_modal";

// Configure defaults for confirm modals (optional - these are already the defaults)
document.addEventListener('DOMContentLoaded', function () {
  // Ensure Rails confirm modal is initialized
  if (typeof initializeRailsConfirmModal === 'function' && !window.railsConfirmModalInitialized) {
    window.railsConfirmModalInitialized = initializeRailsConfirmModal();
  }

  if (typeof railsConfirmModal !== 'undefined') {
    railsConfirmModal.setDefaults({
      title: 'Please Confirm',
      commit: 'OK',
      cancel: 'Cancel'
    });
  }
});
